import React, { useState, useEffect } from "react";
import api from "../api/api";
import { Print } from "@mui/icons-material";
import { useAcademicYear } from "../AcademicYearContext";
import Swal from "sweetalert2";
import { pdf } from "@react-pdf/renderer";
import ReportCardPDF from "./ReportCardPDF";
import HonorStudent from "./HonorStudent";
import ONScreenReportCard from "./ONScreenReportCard";
import {
    Container,
    CircularProgress,
    Button,
    Box,
    Autocomplete,
    TextField,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import JSZip from "jszip";
import { saveAs } from "file-saver";




// ======================================
// COMPONENT START
// ======================================

const ReportCard = () => {


    const { selectedYear } = useAcademicYear();


    const token = localStorage.getItem("access");



    // ======================================
    // GRADE CLASSES
    // ======================================

    const [
        gradeClasses,
        setGradeClasses
    ] = useState([]);



    // ======================================
    // STUDENTS
    // ======================================

    const [
        students,
        setStudents
    ] = useState([]);



    // ======================================
    // SELECTED GRADE CLASS
    // ======================================

    const [
        selectedGradeClass,
        setSelectedGradeClass
    ] = useState(null);



    // ======================================
    // SELECTED STUDENT
    // ======================================

    const [
        selectedStudent,
        setSelectedStudent
    ] = useState(null);



    // ======================================
    // REPORT CARD DATA
    // ======================================

    const [
        reportCard,
        setReportCard
    ] = useState(null);



    // ======================================
    // LOADING
    // ======================================

    const [
        loading,
        setLoading
    ] = useState(false);



    // ======================================
    // PDF REMARK OPTION
    // ======================================

    const [
        showRemarksInPDF,
        setShowRemarksInPDF
    ] = useState(false);



    // ======================================
    // PROMOTION CHECKBOX STATES
    // ======================================

    const [
        promotionChecks,
        setPromotionChecks
    ] = useState({

        promoted:false,

        condition:false,

        fail:false,

        neverToReturn:false,

    });



    // ======================================
    // SEMESTER PERIODS
    // ======================================

    const sem1Periods = [

        "Period 1",

        "Period 2",

        "Period 3",

        "Exam"

    ];



    const sem2Periods = [

        "Period 4",

        "Period 5",

        "Period 6",

        "Exam2"

    ];





    // ======================================
    // FETCH GRADE CLASSES
    // ======================================

    useEffect(() => {


        api.get(

            "/api/users/grade-classes/",

            {
                headers:{
                    Authorization:`Bearer ${token}`
                }
            }

        )

        .then((response)=>{


            setGradeClasses(response.data);


        })

        .catch((error)=>{


            console.error(

                "Grade class fetch error:",

                error

            );


        });


    }, [token]);

    // ======================================
    // FETCH STUDENTS BY CLASS + YEAR
    // ======================================

    useEffect(() => {


        if(
            selectedGradeClass?.id &&
            selectedYear?.id
        ){


            api.get(

                `/students-by-grade-class/?grade_class=${selectedGradeClass.id}&academic_year=${selectedYear.id}`,

                {
                    headers:{
                        Authorization:`Bearer ${token}`
                    }
                }

            )

            .then((response)=>{


                setStudents(response.data);


            })

            .catch((error)=>{


                console.error(

                    "Student fetch error:",

                    error

                );


            });



            setSelectedStudent(null);

            setReportCard(null);


        }
        else{


            setStudents([]);

            setSelectedStudent(null);

            setReportCard(null);


        }


    },[
        selectedGradeClass,
        selectedYear,
        token
    ]);






    // ======================================
    // GENERATE SINGLE STUDENT REPORT CARD
    // ======================================

    const handleGenerateReportCard = async()=>{


        if(!selectedStudent){


            Swal.fire(

                "Error",

                "Please select a student.",

                "error"

            );


            return;

        }



        setLoading(true);



        try{


            const response = await api.post(

                "/api/users/grades-reports/",

                {

                    grade_class:selectedGradeClass.id,

                    student:selectedStudent.id,

                    academic_year:selectedYear?.id,

                },
                

                {

                    headers:{

                        Authorization:`Bearer ${token}`

                    }

                }

            );
console.log("REPORT CARD RESPONSE:", response.data);


            if(

                response.data &&

                Array.isArray(response.data.period_grades)

            ){


                setReportCard(response.data);


                Swal.fire(

                    "Success",

                    "Grade sheet generated successfully",

                    "success"

                );


            }
            else{


                setReportCard(null);


                Swal.fire(

                    "No Grades",

                    "No grades found for this student",

                    "warning"

                );


            }


        }
        catch(error){


            Swal.fire(

                "Error",

                error.response?.data?.error ||

                "Failed to generate report card",

                "error"

            );


        }
        finally{


            setLoading(false);


        }


    };



// ======================================
// DOWNLOAD SINGLE STUDENT REPORT CARD
// ======================================

const handleDownloadStudentReportCard = async () => {

    if (!reportCard) {

        Swal.fire(
            "Error",
            "Please generate the student's report card first.",
            "error"
        );

        return;

    }

    try {

        Swal.fire({

            title: "Generating Report Card",

            text: "Please wait...",

            allowOutsideClick: false,

            didOpen: () => {

                Swal.showLoading();

            }

        });


        const pdfBlob = await pdf(

            <ReportCardPDF

                responses={[

                    {

                        data: reportCard

                    }

                ]}

                selectedGradeClass={selectedGradeClass}

                selectedYear={selectedYear}

                showRemarksInPDF={showRemarksInPDF}

            />

        ).toBlob();


        const cleanName = (

            reportCard.student_name ||

            selectedStudent?.full_name ||

            "Student"

        ).replace(

            /[^a-z0-9]/gi,

            "_"

        );


        saveAs(

            pdfBlob,

            `${cleanName}_ReportCard.pdf`

        );


        Swal.close();


        Swal.fire(

            "Completed",

            "Student report card downloaded successfully.",

            "success"

        );


    }

    catch (error) {


        console.error(

            "Student report card download error:",

            error

        );


        Swal.close();


        Swal.fire(

            "Error",

            "Failed to download student report card.",

            "error"

        );


    }

};




    // ======================================
    // PRINT ALL CLASS REPORT CARDS PDF
    // ======================================

const handlePrintClassReportCards = async () => {

    if (!selectedGradeClass?.id) {
        Swal.fire("Error", "Please select a grade class.", "error");
        return;
    }

    if (!students.length) {
        Swal.fire("Error", "No students found.", "error");
        return;
    }

    setLoading(true);

    try {

        const zip = new JSZip();

        Swal.fire({
            title: "Generating Report Cards",
            text: "Please wait...",
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });


        for (let i = 0; i < students.length; i++) {

            const student = students[i];

            Swal.update({
                text: `Generating ${student.full_name} (${i + 1}/${students.length})`
            });


            const response = await api.post(
                "/api/users/grades-reports/",
                {
                    grade_class: selectedGradeClass.id,
                    student: student.id,
                    academic_year: selectedYear?.id,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );


            if (!response.data?.period_grades) continue;


            const pdfBlob = await pdf(
                <ReportCardPDF
                    responses={[
                        {
                            data: response.data
                        }
                    ]}
                    selectedGradeClass={selectedGradeClass}
                    selectedYear={selectedYear}
                    showRemarksInPDF={showRemarksInPDF}
                />
            ).toBlob();


            const cleanName = student.full_name.replace(
                /[^a-z0-9]/gi,
                "_"
            );


            zip.file(
                `${cleanName}_ReportCard.pdf`,
                pdfBlob
            );


            await new Promise(resolve => setTimeout(resolve, 100));

        }


        const zipBlob = await zip.generateAsync({
            type: "blob",
            compression: "DEFLATE",
            compressionOptions: {
                level: 6
            }
        });


        saveAs(
            zipBlob,
            `${selectedGradeClass.name}_ReportCards.zip`
        );


        Swal.close();

        Swal.fire(
            "Completed",
            "All report cards downloaded successfully.",
            "success"
        );


    } catch (error) {

        console.error(error);

        Swal.fire(
            "Error",
            "Failed generating report cards.",
            "error"
        );

    } finally {

        setLoading(false);

    }

};





    // ======================================
    // PROMOTION CHECKBOX HANDLER
    // ======================================

    const handlePromotionCheckChange = (event)=>{


        const {

            name,

            checked

        } = event.target;



        setPromotionChecks((previous)=>({


            ...previous,


            [name]:checked


        }));


    };

        // ======================================
    // RETURN JSX
    // ======================================

    return (

        <Box
            sx={{
                width:"100%",
                minHeight:"100vh",
                backgroundColor:"#f0f2f5",
                py:4
            }}
        >

            <Container>


                {/* ======================================
                    SELECT CLASS AND STUDENT
                ====================================== */}

                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        mb:2,
                        flexWrap:"wrap"
                    }}
                >


                    <Autocomplete

                        options={gradeClasses}

                        getOptionLabel={(option)=>option.name || ""}

                        value={selectedGradeClass}

                        onChange={(event,value)=>{

                            setSelectedGradeClass(value);

                        }}

                        renderInput={(params)=>(

                            <TextField

                                {...params}

                                label="Select Grade Class"

                            />

                        )}

                        sx={{
                            minWidth:250,
                            flex:1
                        }}

                    />





                    <Autocomplete

                        options={students}

                        getOptionLabel={(option)=>option.full_name || ""}

                        value={selectedStudent}

                        onChange={(event,value)=>{

                            setSelectedStudent(value);

                        }}

                        disabled={!selectedGradeClass}

                        renderInput={(params)=>(

                            <TextField

                                {...params}

                                label="Select Student"

                            />

                        )}

                        sx={{
                            minWidth:250,
                            flex:1
                        }}

                    />



                </Box>






                {/* ======================================
                    BUTTON AREA
                ====================================== */}


                <Box
                    sx={{
                        display:"flex",
                        gap:2,
                        mb:2,
                        p:1,
                        flexWrap:"wrap",
                        backgroundColor:"#fad380ff",
                        borderRadius:1
                    }}
                >



                    <Button

                        variant="contained"

                        onClick={handleGenerateReportCard}

                        disabled={!selectedStudent || loading}

                    >

                        {

                            loading ?

                            <CircularProgress size={24}/>

                            :

                            "Generate Report Card"

                        }


                    </Button>






                    <Button

                        variant="outlined"

                        color="secondary"

                        startIcon={<Print/>}

                        onClick={handlePrintClassReportCards}

                        disabled={

                            !selectedGradeClass ||

                            students.length===0

                        }

                    >

                        Print Class Report Cards


                    </Button>







                    <FormControlLabel

                        control={

                            <Checkbox

                                checked={showRemarksInPDF}

                                onChange={(event)=>{

                                    setShowRemarksInPDF(

                                        event.target.checked

                                    );

                                }}

                            />

                        }

                        label="Include actual remarks in PDF"

                    />



                </Box>







                {/* ======================================
                    HONOR STUDENTS
                ====================================== */}


                <Box>

                    <HonorStudent />

                </Box>







                {/* ======================================
                    ON SCREEN REPORT CARD
                ====================================== */}


                {

                    reportCard && (

                        <ONScreenReportCard

    reportCard={reportCard}

    promotionChecks={promotionChecks}

    handlePromotionCheckChange={
        handlePromotionCheckChange
    }

    selectedYear={selectedYear}

    selectedGradeClass={selectedGradeClass}

    students={students}

    handleDownloadStudentReportCard={
        handleDownloadStudentReportCard
    }

/>

                    )

                }



            </Container>


        </Box>

    );


};


export default ReportCard;


